module.exports = __webpack_public_path__ + "img/icon-offers.8326f730.svg";